/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_SegmentInputs */

const en_ad_section_segment = /** @type {(inputs: Ad_Section_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment to Process`)
};

const fr_ad_section_segment = /** @type {(inputs: Ad_Section_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmenter vers Processus`)
};

const de_ad_section_segment = /** @type {(inputs: Ad_Section_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment zum Verarbeiten`)
};

const it_ad_section_segment = /** @type {(inputs: Ad_Section_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmento per elaborare`)
};

const ru_ad_section_segment = /** @type {(inputs: Ad_Section_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сегмент для обработки`)
};

const es_ad_section_segment = /** @type {(inputs: Ad_Section_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentar para procesar`)
};

const zh_cn2_ad_section_segment = /** @type {(inputs: Ad_Section_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分段处理`)
};

const ja_ad_section_segment = /** @type {(inputs: Ad_Section_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメントからプロセスへ`)
};

const hi_ad_section_segment = /** @type {(inputs: Ad_Section_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रक्रिया के लिए खंड`)
};

const pt_pt2_ad_section_segment = /** @type {(inputs: Ad_Section_SegmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentar para Processar`)
};

/**
* | output |
* | --- |
* | "Segment to Process" |
*
* @param {Ad_Section_SegmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_segment = /** @type {((inputs?: Ad_Section_SegmentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_SegmentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_section_segment(inputs)
	if (locale === "de") return de_ad_section_segment(inputs)
	if (locale === "it") return it_ad_section_segment(inputs)
	if (locale === "ru") return ru_ad_section_segment(inputs)
	if (locale === "es") return es_ad_section_segment(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_section_segment(inputs)
	if (locale === "ja") return ja_ad_section_segment(inputs)
	if (locale === "hi") return hi_ad_section_segment(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_section_segment(inputs)
	return en_ad_section_segment(inputs)
});